// AuthReducer.js
import { CURRENT, FAIL, GETALLUSERS, GETONEUSER, LOGIN, LOGOUT, REGISTER } from "../ActionTypes/AuthTypes"

const initialState = {
 user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null,
  token: localStorage.getItem("token") || null,
  isAuth: !!localStorage.getItem("token"),
  load: false,
  errors: [],
  users: []
}

const AuthReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case REGISTER:
      return {
        ...state,
        load: false,
        user: payload.newUser || payload.user, // ✅ Sécurisé
        token: payload.token
      }

    case LOGIN:
      // 🔥 CORRECTION : Vérifier que payload n'est pas undefined
      if (!payload) {
        console.error('❌ PAYLOAD UNDEFINED DANS LOGIN');
        return state;
      }

      return {
        ...state,
        load: false,
        // ✅ Utiliser payload.user OU payload.found pour la compatibilité
        user: payload.user || payload.found || null,
        token: payload.token,
        isAuth: true,
        errors: []
      }

    case CURRENT:
      return {
        ...state,
        load: false,
        user: payload || payload.user || null, // ✅ Sécurisé
        isAuth: true
      }

    case FAIL:
      return {
        ...state,
        load: false,
        errors: payload || [] // ✅ Éviter undefined
      }

    case LOGOUT:
      return initialState

    case GETALLUSERS:
      return {
        ...state,
        load: false,
        users: payload || [] // ✅ Sécurisé
      }

    case GETONEUSER:
      return {
        ...state,
        load: false,
        user: payload || null // ✅ Sécurisé
      }

    default:
      return state
  }
}

export default AuthReducer